import React from 'react'
import { connect } from 'react-redux'
import Assessment from '../index'
import selectors from '../selectors'
import {
  fetchAssessmentQuestions,
  saveQuestionResponse,
  fetchActiveAssessments,
  fetchCompletedAssessments,
  setActiveAssessmentFilters,
  setCompletedAssessmentFilters,
  setCurrentAssessmentId,
  fetchCommunicationInstructions,
  fetchReports,
} from '../actions'

// console.log('Assessments Container')

const mapStateToProps = state => ({
  questions: selectors.getQuestions(state),
  totalQuestions: selectors.getTotalQuestions(state),
  loading: selectors.getLoading(state),
  error: selectors.getError(state),
  responses: selectors.getResponses(state),
  currentBehaviorId: selectors.getCurrentBehaviorId(state),

  activeAssessments: selectors.getActiveAssessments(state),
  activeAssessmentsLoading: selectors.getActiveAssessmentsLoading(state),
  activeAssessmentsError: selectors.getActiveAssessmentsError(state),
  activeAssessmentsFilters: selectors.getActiveAssessmentsFilters(state),

  completedAssessments: selectors.getCompletedAssessments(state),
  completedAssessmentsLoading: selectors.getCompletedAssessmentsLoading(state),
  completedAssessmentsError: selectors.getCompletedAssessmentsError(state),
  completedAssessmentsFilters: selectors.getCompletedAssessmentsFilters(state),

  reports: selectors.getReports(state),
  reportsLoading: selectors.getReportsLoading(state),
  reportsError: selectors.getReportsError(state),
})

const mapDispatchToProps = {
  fetchAssessmentQuestions,
  saveQuestionResponse,
  fetchActiveAssessments,
  fetchCompletedAssessments,
  fetchCommunicationInstructions,
  setActiveAssessmentFilters,
  setCompletedAssessmentFilters,
  setCurrentAssessmentId,
  fetchReports,
}

const ConnectedAssessment = connect(
  mapStateToProps,
  mapDispatchToProps
)(Assessment)

export default ConnectedAssessment
